<template>
  <div class="ch-component-warpper">
    <div class="ch-component">
      <!-- <button
        class="ch-floating-btn ch-menu-btn"
        @click="openDialog"
      >
        <span><i class="far fa-plus-square fa-fw"></i></span>
        DOORLOCK
      </button> -->
      <v-container fluid grid-list-lg class="ch-menu-wrapper">
        <div class="ch-menu-title">
          <!-- <button @click.stop="toogleDrawer" class="ch-menu-btn ch-navigation-toogle" type="button">
            <span class="ch-menu-btn-icon" v-show="navigationDrawer">
              <i class="fas fa-minus fa-fw"></i>
            </span>
            <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
              <i class="fas fa-plus fa-fw"></i>
            </span>
          </button> -->
          <span class="ch-component-title pl-2">DOORLOCK</span>
        </div>
        <div class="filter-body-wrapper">
          <doorlocks-filter :storeFilter="storeFilter"></doorlocks-filter>
        </div>
      </v-container>
      <v-container fluid grid-list-lg class="pt-4">
        <doorlocks-list :storeFilter="storeFilter" :storePage="storePage"></doorlocks-list>
      </v-container>
      <create-doorlock></create-doorlock>
      <scroll-event></scroll-event>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import { doorlocksEventBus } from '@/components/admin/doorlocks/doorlocksEventBus';
  import DoorlocksFilter from '@/components/admin/doorlocks/DoorlocksFilter';
  import DoorlocksList from '@/components/admin/doorlocks/DoorlocksList';
  import CreateDoorlock from '@/components/admin/doorlocks/CreateDoorlock';
  import ScrollEvent from '@/components/customized-components/ScrollEvent';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        navigationDrawer: true,
      };
    },
    methods: {
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
      openDialog() {
        doorlocksEventBus.$emit('openDialog');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      DoorlocksFilter, DoorlocksList, CreateDoorlock, ScrollEvent,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Doorlocks.vue